import { motion, useInView, useReducedMotion } from "framer-motion";
import { useRef } from "react";

const EASE = [0.22, 1, 0.36, 1];

export function RevealLines({ text, as = "h1", className = "", delay = 0, lineClass = "" }) {
  const reducedMotion = useReducedMotion();
  if (reducedMotion) {
    const Heading = as;
    return <Heading className={className}>{text}</Heading>;
  }
  const Tag = motion[as] || motion.div;
  const words = text.split(" ");
  return (
    <Tag className={className} initial="hidden" animate="show" aria-label={text}>
      {words.map((w, i) => (
        <span key={i} className="inline-block overflow-hidden align-bottom pb-[0.08em] -mb-[0.08em]">
          <motion.span
            className={`inline-block ${lineClass}`}
            variants={{ hidden: { y: "110%", opacity: 0 }, show: { y: 0, opacity: 1 } }}
            transition={{ duration: 0.9, ease: EASE, delay: delay + i * 0.035 }}
          >
            {w}&nbsp;
          </motion.span>
        </span>
      ))}
    </Tag>
  );
}

export function FadeUp({ children, delay = 0, className = "", y = 28, once = true }) {
  const ref = useRef(null);
  const reducedMotion = useReducedMotion();
  const inView = useInView(ref, { once, amount: "some" });
  if (reducedMotion) return <div className={className}>{children}</div>;
  return (
    <motion.div
      ref={ref}
      className={className}
      initial={{ opacity: 0, y }}
      animate={inView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.9, ease: EASE, delay }}
    >
      {children}
    </motion.div>
  );
}

export function Stagger({ children, className = "", stagger = 0.08 }) {
  const ref = useRef(null);
  const reducedMotion = useReducedMotion();
  // A whole grid can be taller than the viewport: reveal on its first intersection.
  const inView = useInView(ref, { once: true, amount: "some" });
  if (reducedMotion) return <div className={className}>{children}</div>;
  return (
    <motion.div
      ref={ref}
      className={className}
      initial="hidden"
      animate={inView ? "show" : "hidden"}
      variants={{ show: { transition: { staggerChildren: stagger } } }}
    >
      {children}
    </motion.div>
  );
}

export const item = {
  hidden: { opacity: 0, y: 30 },
  show: { opacity: 1, y: 0, transition: { duration: 0.85, ease: EASE } },
};
